<template>
  <div class="wrapper__content-sale-document col-container">
    <div class="col-header">
      <div class="col-header-left">
        <ButtonCirclePlusComponent
          v-if="$canOpen('sales.liquidations.add')"
          @onClick="liquidationAdd"
        />
        <span class="col-title">Liquidación de Compras</span>
      </div>
      <div class="col-actions">
        <ButtonFilterComponent
          @onChangeFilters="onChangeFilters"
          @onApplyFilters="onApplyFilters"
          @onResetFilters="onResetFilters"
          :setFilters="searchFilters"
          :loading="loading"
          :setStatus="filterStatus"
          placeholder="Buscar por número documento"
          isStatus
          isSearch
          isOrderBy
          isDates
          isClients
          class="mx-2"
        >
          <template slot="customs">
            <p class="pb-2 m-0 mt-2 font-bold text-color-blank">Buscar por</p>

            <el-radio-group
              v-model="filterIsPaid"
              @change="onChangeFilterLocal"
            >
              <el-radio class="d-block mb-1" label="1">Pagada</el-radio>
              <el-radio class="d-block mb-1" label="0">No pagada</el-radio>
            </el-radio-group>
          </template>
        </ButtonFilterComponent>
      </div>
    </div>
    <template>
      <WrapperScrollbarComponent @scrollingEnd="infiniteHandler">
        <LiquidationCardComponent
          v-for="(liquidation, index) in filterLiquidations"
          :key="liquidation.id || index"
          :liquidation="liquidation"
          @onDocUpdate="onDocUpdate"
          @onDocDeleted="onDocDeleted"
        />
        <infinite-loading
          @distance="90"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <SkeletonOneCardComponent />
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <LiquidationEmptyComponent v-if="!liquidations.length" />
          </div>
        </infinite-loading>
      </WrapperScrollbarComponent>
    </template>
  </div>
</template>

<script>
import ButtonCirclePlusComponent from "../../../components/ButtonCirclePlus";
import ButtonFilterComponent from "../../../components/DrawerFilter";
import LiquidationEmptyComponent from "./Empty";
import LiquidationCardComponent from "./LiquidationCard";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";
import WrapperScrollbarComponent from "../../../../components/WrapperScrollbar";

import liquidationService from "../services/liquidationService";

export default {
  name: "LiquidationColumnsComponent",
  data() {
    return {
      loading: true,
      searchFilters: {},
      filterIsPaid: null,
      filterStatus: [
        {
          label: "Borrador",
          key: "draft"
        },
        {
          label: "Aprobada",
          key: "success"
        },
        {
          label: "Anulada",
          key: "nuled"
        },
        {
          label: "Fallida",
          key: "failed"
        }
      ],
      page: 1,
      liquidations: [],
      breakScroll: false
    };
  },
  computed: {
    filterOrderBy() {
      const { orderBy } = this.searchFilters;
      return orderBy;
    },
    requestFilters() {
      const { search, from, to, status, clientId: client } = this.searchFilters;
      // Only include defined/non-null values to prevent API confusion
      const filters = {};
      if (search) filters.search = search;
      if (from) filters.from = from;
      if (to) filters.to = to;
      if (status) filters.status = status;
      if (client) filters.client = client;
      return filters;
    },
    filterLiquidations() {
      return this.liquidations.concat().sort((a, b) => {
        if (this.filterOrderBy && this.filterOrderBy === "desc") {
          return a.total > b.total ? -1 : 1;
        } else if (this.filterOrderBy && this.filterOrderBy === "asc") {
          return a.total < b.total ? -1 : 1;
        }
        // Default: sort by date descending (most recent first)
        const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
        const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
        return dateB - dateA;
      });
    },
    getLiquidationsFilters() {
      const { documents } = this.$store.getters.getModule("sales");
      return documents.liquidations.filters.get;
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    liquidationAdd() {
      this.goRouter("sales.liquidations.add");
    },
    onChangeFilterLocal() {
      this.updatedSearchFilters({
        is_paid: this.filterIsPaid
      });
    },
    updatedSearchFilters(filters) {
      this.searchFilters = {
        ...this.searchFilters,
        ...filters
      };

      this.$store.dispatch("salesDocumentsFiltersGet", {
        documentKey: "liquidations",
        filters: this.searchFilters
      });
    },
    onChangeFilters(filters) {
      this.updatedSearchFilters(filters);
    },
    onApplyFilters() {
      this.onAsyncDataForDates();
    },
    onResetFilters() {
      this.filterIsPaid = null;

      this.onChangeFilterLocal();
    },
    onAsyncDataForDates() {
      this.liquidations = [];
      this.page = 1;
      // El aviso de refresco llega con debounce: el componente puede haberse
      // desmontado (navegación) antes de que corra.
      if (!this.$refs.infiniteLoading) return;
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    onDocUpdate({ id, data }) {
      const idx = this.liquidations.findIndex(d => d.id === id);
      if (idx !== -1) this.$set(this.liquidations, idx, data);
    },
    onDocDeleted(id) {
      this.liquidations = this.liquidations.filter(d => d.id !== id);
    },
    async getLiquidations($state) {
      try {
        this.loading = true;
        let response = await liquidationService
          .getLiquidations({
            params: {
              ...{
                page: this.page,
                client: this.getClientId,
                is_paid: this.filterIsPaid
              },
              ...this.requestFilters
            }
          })
          .finally(() => {
            this.breakScroll = false;
            this.loading = false;
          });
        const { data } = response.data || {};
        // El interceptor de Api.js "silencia" los GET cancelados por deduplicación
        // devolviendo { data: {} }. Sin este guard, data.length revienta, el catch
        // se lo traga y $state nunca se resuelve: el infinite-loading queda colgado
        // y la columna solo vuelve a cargar recargando la página entera.
        if (!Array.isArray(data)) {
          $state.loaded();
          return;
        }

        if (data.length) {
          if (this.page === 1) {
            this.liquidations = data;
          } else {
            // Deduplicate: only push items not already in the list
            const existingIds = new Set(this.liquidations.map(l => l.id));
            const newItems = data.filter(item => !existingIds.has(item.id));
            if (newItems.length === 0) {
              // All returned items are already shown — no more unique data
              $state.complete();
              return;
            }
            newItems.forEach(item => this.liquidations.push(item));
          }
          this.page = this.page + 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        return false;
      }
    },
    infiniteHandler($state) {
      if (!$state || typeof $state.complete !== "function") return;
      if (this.breakScroll) return false;
      this.breakScroll = true;
      this.getLiquidations($state);
    },
    setInitFilters() {
      // All filters
      this.searchFilters = this.getLiquidationsFilters;

      // Local filters
      this.filterIsPaid = this.getLiquidationsFilters?.is_paid;
    }
  },
  components: {
    ButtonCirclePlusComponent,
    ButtonFilterComponent,
    LiquidationEmptyComponent,
    LiquidationCardComponent,
    SkeletonOneCardComponent,
    WrapperScrollbarComponent
  },
  props: {
    getClientId: {
      default: null
    }
  },
  mounted() {
    this.setInitFilters();
  }
};
</script>

<style lang="scss" scoped></style>
